export default "__VITE_ASSET__CQ2JbkYI__"